module.exports = "https://static.wmbcdn.com/uniweb/images/da6d5552319da1618c7d2889e125b625.svg";